import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import SectionContainer from '../SectionContainer';
import Field, { hasDataInFields } from '../../Field';
import { AspectRatioWrapper, IconClock } from '../../../../components';

import css from './SectionTutorTestimonials.module.css';
import img1 from './images/1.png';
import img2 from './images/2.png';
import img3 from './images/3.png';
import img4 from './images/4.png';
import pattern from './images/pattern.svg';

const SectionTutorTestimonials = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    numColumns,
    title,
    description,
    appearance,
    callToAction,
    blocks,
    isInsideContainer,
    options,
    intl,
  } = props;

  // If external mapping has been included for fields
  // E.g. { h1: { component: MyAwesomeHeader } }
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);

  const aspectWidth = 1;
  const aspectHeight = 1;
  return (
    <SectionContainer
      id={sectionId}
      className={classNames(className)}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      <div className={css.container}>
        {hasHeaderFields ? (
          <header className={classNames(css.header, defaultClasses.sectionDetails)}>
            <Field data={title} className={defaultClasses.title} options={fieldOptions} />
            <Field
              data={description}
              className={defaultClasses.description}
              options={fieldOptions}
            />
          </header>
        ) : null}

        <div className={css.blocksWrapper}>
          <div className={css.block}>
            <AspectRatioWrapper
              className={css.aspectRatioWrapper}
              width={aspectWidth}
              height={aspectHeight}
            >
              <img className={css.rootForImage} alt={'tutor'} src={img1} />
            </AspectRatioWrapper>
            <div className={css.info}>
              <div className={css.name}>
                {intl.formatMessage({
                  id: 'LandingPage.SectionTutorTestimonials.1.name',
                })}
              </div>
              <div className={css.duration}>
                <IconClock className={css.iconClock} />
                {intl.formatMessage({
                  id: 'LandingPage.SectionTutorTestimonials.1.duration',
                })}
              </div>
              <div className={css.testimonial}>
                {intl.formatMessage({
                  id: 'LandingPage.SectionTutorTestimonials.1.testimonial',
                })}
              </div>
            </div>
          </div>
          <div className={css.block}>
            <AspectRatioWrapper
              className={css.aspectRatioWrapper}
              width={aspectWidth}
              height={aspectHeight}
            >
              <img className={css.rootForImage} alt={'tutor'} src={img2} />
            </AspectRatioWrapper>
            <div className={css.info}>
              <div className={css.name}>
                {intl.formatMessage({
                  id: 'LandingPage.SectionTutorTestimonials.2.name',
                })}
              </div>
              <div className={css.duration}>
                <IconClock className={css.iconClock} />
                {intl.formatMessage({
                  id: 'LandingPage.SectionTutorTestimonials.2.duration',
                })}
              </div>
              <div className={css.testimonial}>
                {intl.formatMessage({
                  id: 'LandingPage.SectionTutorTestimonials.2.testimonial',
                })}
              </div>
            </div>
          </div>
          <div className={css.block}>
            <AspectRatioWrapper
              className={css.aspectRatioWrapper}
              width={aspectWidth}
              height={aspectHeight}
            >
              <img className={css.rootForImage} alt={'tutor'} src={img3} />
            </AspectRatioWrapper>
            <div className={css.info}>
              <div className={css.name}>
                {intl.formatMessage({
                  id: 'LandingPage.SectionTutorTestimonials.3.name',
                })}
              </div>
              <div className={css.duration}>
                <IconClock className={css.iconClock} />
                {intl.formatMessage({
                  id: 'LandingPage.SectionTutorTestimonials.3.duration',
                })}
              </div>
              <div className={css.testimonial}>
                {intl.formatMessage({
                  id: 'LandingPage.SectionTutorTestimonials.3.testimonial',
                })}
              </div>
            </div>
          </div>
          <div className={css.block}>
            <AspectRatioWrapper
              className={css.aspectRatioWrapper}
              width={aspectWidth}
              height={aspectHeight}
            >
              <img className={css.rootForImage} alt={'tutor'} src={img4} />
            </AspectRatioWrapper>
            <div className={css.info}>
              <div className={css.name}>
                {intl.formatMessage({
                  id: 'LandingPage.SectionTutorTestimonials.4.name',
                })}
              </div>
              <div className={css.duration}>
                <IconClock className={css.iconClock} />
                {intl.formatMessage({
                  id: 'LandingPage.SectionTutorTestimonials.4.duration',
                })}
              </div>
              <div className={css.testimonial}>
                {intl.formatMessage({
                  id: 'LandingPage.SectionTutorTestimonials.4.testimonial',
                })}
              </div>
            </div>
          </div>
        </div>
        <img className={css.pattern} src={pattern} alt="pattern" />
      </div>
    </SectionContainer>
  );
};

SectionTutorTestimonials.defaultProps = {
  className: null,
  rootClassName: null,
};

SectionTutorTestimonials.propTypes = {
  sectionId: string.isRequired,
  className: string,
  rootClassName: string,
};

export default SectionTutorTestimonials;
